import { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import { profileUpdater, sendEvent, setProfile } from '@sbol/clickstream-agent';
import { PageLoader } from '@/shared/ui/PageLoader';
import { Wrapper } from '@/shared/ui/Wrapper';
import { useOAuth } from '@/features/PolicyRegistration/lib/query/useOAuth';
import { getCookie } from '@/shared/lib/utils/getCookie';
import {
    AUTH_PROVIDERS,
    getExtSub,
    getExtUuid,
    getIdentityProvider,
    getToken,
    SHOULD_AUTH_WITH_ESIA_COOKIE,
    SHOULD_AUTH_WITH_SBER_ID_COOKIE,
    SHOULD_SHOW_SECOND_FORM_COOKIE,
} from '@/shared/lib/keycloack/init';
import { usePolicyStore } from '@/entities/Policy/model/store';
import { removeCookie } from '@/shared/lib/utils/removeCookie';
import { setCookie } from '@/shared/lib/utils/setCookie';
import { getHashUserLoginId } from '@/shared/lib/clickstream-agent/utils';

const AuthPage = () => {
    const { keycloak } = useKeycloak();
    const navigate = useNavigate();
    const { mutate: getUserData } = useOAuth();
    const { setError } = usePolicyStore();

    useEffect(() => {
        if (!keycloak.didInitialize) {
            return;
        }

        setTimeout(() => {
            const shouldAuthWithSberId = getCookie(SHOULD_AUTH_WITH_SBER_ID_COOKIE);
            const shouldAuthWithEsia = getCookie(SHOULD_AUTH_WITH_ESIA_COOKIE);

            if (!keycloak.authenticated && shouldAuthWithSberId) {
                removeCookie(SHOULD_AUTH_WITH_SBER_ID_COOKIE);
                setCookie(SHOULD_SHOW_SECOND_FORM_COOKIE, 'true', 1);
                keycloak.login({
                    idpHint: AUTH_PROVIDERS.sberId,
                });
                return;
            }

            if (!keycloak.authenticated && shouldAuthWithEsia) {
                removeCookie(SHOULD_AUTH_WITH_ESIA_COOKIE);
                setCookie(SHOULD_SHOW_SECOND_FORM_COOKIE, 'true', 1);
                keycloak.login({
                    idpHint: AUTH_PROVIDERS.esia,
                });
                return;
            }

            if (keycloak.authenticated && getCookie(SHOULD_SHOW_SECOND_FORM_COOKIE) === 'true') {
                const token = getToken(keycloak);
                const authType = getIdentityProvider(keycloak) === AUTH_PROVIDERS.esia ? 'esia' : 'sberId';
                const id = getCookie('xguid');
                getUserData(
                    {
                        id,
                        token,
                        authType,
                    },
                    {
                        onError: () => {
                            setError('Не удалось получить данные пользователя');
                        },
                    }
                );
                removeCookie(SHOULD_SHOW_SECOND_FORM_COOKIE);
            }

            if (getCookie('acquiringSuccess') === 'true') {
                navigate('/acquiring/success', { replace: true });
                removeCookie('acquiringSuccess');
                return;
            }

            if (getCookie('acquiringFail') === 'true') {
                navigate('/acquiring/fail', { replace: true });
                removeCookie('acquiringFail');
                return;
            }

            // Если пользователь не авторизован или нет куки, редиректим на главную
            navigate('/', { replace: true });

            // настройка кликстрим
            setProfile({
                clientBlock: getIdentityProvider(keycloak),
                hashUserLoginId: getHashUserLoginId(),
                appVersion: '1.0',
            });
            profileUpdater.setProfileID('sbClientId', getExtSub(keycloak), false);
            profileUpdater.setProfileID('clientId', getExtUuid(keycloak), false);

            sendEvent({
                eventCategory: 'sberinsur',
                eventAction: 'Открытие Надёжный заёмщик',
                value: '',
            });
        }, 1000);

        // Если пользователь авторизован и есть кука shouldShowSecondForm, получаем данные
    }, [keycloak.didInitialize]);

    return (
        <Wrapper>
            <PageLoader />
        </Wrapper>
    );
};

export default AuthPage;
